export const STRINGS = {
  studio: 'Studio',
  save: 'Simpan',
  share: 'Bagikan',
  play: 'Mainkan',
  edit: 'Edit',
  back: 'Kembali',
  close: 'Tutup',
  loading: 'Memuat…',
  error: 'Hmm, ada yang perlu diperbaiki',
  retry: 'Coba lagi',

  // Mode labels (F-01)
  modeBuild: 'Buat',
  modePlay: 'Mainkan',
  modeShare: 'Bagikan',

  // Mode placeholders (F-01)
  buildPlaceholderTitle: 'Area Bikin',
  buildPlaceholderBody: 'Tempat blok-blok kamu akan ditaruh di sini.',
  playPlaceholderTitle: 'Area Main',
  playPlaceholderBody: 'Hasil game kamu akan muncul di sini.',
  sharePlaceholderTitle: 'Area Bagikan',
  sharePlaceholderBody: 'Link untuk dibagikan ke teman atau orang tua.',

  // Play mode UI (NEW F-04)
  playTitle: 'Lagi Main',
  playLoading: 'Menyiapkan game...',
  actionEdit: 'Edit',

  // Error overlay (NEW F-04)
  errorOverlayTitle: 'Hmm, ada yang perlu diperbaiki',
  errorOverlayDismiss: 'Oke, aku coba lagi!',
  errorOverlayDetailsLabel: 'Detail (untuk orang tua)',

  // Header actions (F-01)
  actionSave: 'Simpan',
  actionShare: 'Bagikan',
  actionHelp: 'Bantuan',

  // Misc (F-01)
  appTitle: 'TM Studio',

  // Events block labels (F-02)
  blockEventStart: '🏁 saat mulai',
  blockEventSpriteClick: '👆 saat Klik [SPRITE]',
  blockEventCollide: '🤝 saat Tumbukan [SPRITE] dengan [SPRITE]',
  blockEventKey: '⌨️ saat Tekan [PANAH]',
  blockEventInterval: '🔁 setiap [DETIK] detik',

  // Blockly toolbox (F-02)
  toolboxCategoryEvents: 'Kapan program jalan?',
  toolboxCategoryHint: 'Pilih kategori, lalu tap blok untuk menambah',

  // Mobile toolbar (F-02)
  toolbarZoomIn: 'Perbesar',
  toolbarZoomOut: 'Perkecil',
  toolbarZoomReset: 'Reset',
  toolbarClearAll: 'Hapus semua',
  toolbarCenter: 'Tengahkan',

  // Context menu (F-02)
  contextMenuDelete: '🗑️ Hapus',
  contextMenuDuplicate: '⎘ Duplikat',
  contextMenuUp: '⬆️ Pindah ke atas',
  contextMenuDown: '⬇️ Pindah ke bawah',
  contextMenuViewCode: '👁️ Lihat kode',
  contextMenuRunCode: '▶ Jalankan kode',

  // Workspace (F-02)
  workspaceEmpty: 'Tap kategori di atas, lalu tap blok untuk menambah ke sini.',
  workspaceTapHint: 'Tap blok di sini 👆',

  // Motion block labels (F-03)
  blockMotionRight: '➡️ gerak [SPRITE] ke kanan [PIXEL]',
  blockMotionLeft: '⬅️ gerak [SPRITE] ke kiri [PIXEL]',
  blockMotionUp: '⬆️ gerak [SPRITE] ke atas [PIXEL]',
  blockMotionDown: '⬇️ gerak [SPRITE] ke bawah [PIXEL]',
  blockMotionJump: '🦘 loncat [SPRITE]',
  blockMotionGoto: '🎯 ke [SPRITE] goto x=[X] y=[Y]',

  // Looks block labels (F-03)
  blockLooksShow: '👁️ tampilkan [SPRITE]',
  blockLooksHide: '🙈 sembunyikan [SPRITE]',
  blockLooksScale: '🎨 ubah ukuran [SPRITE] ke [%]',
  blockLooksSay: '💬 katakan [TEXT] selama [DETIK]',

  // Sound block labels (F-03)
  blockSoundPlay: '🔊 bunyi [SOUND]',
  blockSoundLoop: '🎵 audio loop [AUDIO]',
  blockSoundStop: '🔇 stop bunyi',

  // Logic block labels (F-03)
  blockLogicIf: '❓ kalau [COND] maka',
  blockLogicIfElse: '❓ kalau [COND] maka ... kalau tidak',
  blockLogicEqual: '⚖️ [A] = [B]',
  blockLogicLess: '⚖️ [A] < [B]',
  blockLogicGreater: '⚖️ [A] > [B]',
  blockLogicTouching: '🤝 menyentuh [SPRITE]?',

  // Loop block labels (F-03)
  blockLoopRepeat: '🔁 ulang [N] kali',
  blockLoopForever: '🔂 selamanya',
  blockLoopWait: '⏸️ tunggu [DETIK] detik',
  blockLoopWaitUntil: '🚦 tunggu sampai [COND]',

  // End block labels (F-03)
  blockEndStop: '🛑 berhenti semua',

  // Toolbox categories (F-03)
  toolboxCategoryMotion: 'Gerak karakter',
  toolboxCategoryLooks: 'Tampilan',
  toolboxCategorySound: 'Bunyi',
  toolboxCategoryLogic: 'Kalau...maka...',
  toolboxCategoryLoop: 'Ulang',
  toolboxCategoryEnd: 'Akhir',

  // Code overlay (F-03)
  codeOverlayTitle: 'Kode yang dibuat',
  codeOverlayCopy: 'Salin kode',
  codeOverlayClose: 'Tutup',
  codeOverlayEmpty: 'Belum ada blok. Tambah blok dulu untuk lihat kode.',
  codeOverlayInvalid: 'Kode tidak valid. Hubungi tim TM.',

  // Template selector (F-05)
  templateSelectorTitle: 'Pilih Game',
  templateSelectorClose: 'Tutup',
  templateSelectorEmpty: 'Belum ada proyek tersimpan. Mulai dari template di atas!',
  projectTileMeta: '%s · %dx main',

  // Sprite picker (F-05)
  spritePickerToggle: '🎨 Aset',
  spritePickerTitle: 'Pilih Sprite',
  spritePickerAddTitle: 'Tambah "%s"',
  spritePickerPosX: 'Posisi X',
  spritePickerPosY: 'Posisi Y',
  spritePickerCenter: '🎯 Tengah',
  spritePickerConfirm: 'Tambah',
  spritePickerCancel: 'Batal',
  spritePickerBadge: '✓ ×%d',

  // Header actions (F-05)
  headerSave: '💾 Simpan',
  headerProjects: '📂 Proyek',
  headerNew: '🆕 Baru',

  // Toast (F-05)
  toastSaved: '✅ Tersimpan',
  toastSaveError: '⚠️ Gagal simpan: %s',
  toastQuotaExceeded: '⚠️ Penyimpanan penuh. Hapus proyek lama.',

  // Confirm dialog (F-05)
  confirmNewProjectTitle: 'Buat proyek baru?',
  confirmNewProjectMessage: 'Proyek sekarang akan ditutup. Yakin?',
  confirmNewProjectConfirm: 'Ya, buat baru',
  confirmDeleteProjectTitle: 'Hapus proyek "%s"?',
  confirmDeleteProjectMessage: 'Tindakan ini tidak bisa dibatalkan.',

  // Math blocks (F-05 extension)
  toolboxCategoryMath: 'Angka',
  blockMathRandom: '🎲 acak dari [MIN] sampai [MAX]',
  blockMathNumber: '🔢 [NUM]',
  blockSpriteRef: 'sprite [NAME]',

  // Auto-save status (F-06 Phase A)
  headerSaveStatusIdle: 'Simpan',
  headerSaveStatusDirty: '⏳ Belum disimpan',
  headerSaveStatusSaving: '⏳ Menyimpan…',
  headerSaveStatusSaved: '✅ Tersimpan',
  headerSaveStatusError: '⚠️ Gagal simpan',
  autoSaveEnabled: 'Auto-save aktif',
  autoSaveError: 'Gagal simpan otomatis. Tekan 💾 untuk coba lagi.',

  // Share modal (F-06 Phase B)
  headerShare: '🔗 Bagikan',
  shareEmptyTitle: 'Belum ada proyek',
  shareEmptyBody: 'Pilih atau buat proyek dulu sebelum share.',
  shareModalTitle: '🎉 Bagikan Kreasi Kamu',
  shareModalDesc: 'Teman & keluarga bisa main game kamu dengan scan QR atau buka link.',
  shareCopyLink: '📋 Copy Link',
  shareCopied: '✅ Link disalin',
  shareCopyFailed: '⚠️ Gagal copy. Salin manual dari kolom URL.',
  shareScreenshot: '📸 Simpan Screenshot',
  shareScreenshotSoon: 'Segera hadir',
  sharePrivacyNotice: 'Link ini bisa dibuka siapa saja. Jangan share info pribadi.',
  shareConfirmTitle: 'Bagikan kreasi kamu?',
  shareConfirmOptIn: 'Link ini akan bisa dibuka siapa saja. Lanjutkan?',
  shareConfirmYes: 'Ya, bagikan',
  shareConfirmNo: 'Batal',
  shareUrlTooLong: 'Proyek terlalu besar untuk di-share. Hapus beberapa blok.',
  shareQrFailed: 'QR gagal dibuat. Copy link tetap bisa dipakai.',
  shareProjectNameHint: '%s · klik 📋 untuk copy',
  shareEventModalOpened: 'share_modal_opened',
  shareEventLinkGenerated: 'share_link_generated',
  shareEventLinkCopied: 'share_link_copied',

  // Play page (F-06 Phase B)
  playPageTitle: '🎮 Game buatan %s',
  playPageCta: 'Buat game sendiri juga!',
  playPageInvalidLink: 'Link tidak valid atau proyek sudah dihapus.',
  playPageBootError: 'Gagal menjalankan game: %s',
  playPageBackToStudio: '🎮 Buat game sendiri',

  // Play-mode styles reuse (F-04)
  playModeCss: '/src/styles/play-mode.css',
  playPageCss: '/src/styles/play-page.css',

  // Onboarding tour (F-07 Sesi 1)
  onboardingSesi1Title: '🎉 Selamat datang di TM Studio!',
  onboardingSesi1Body:
    'Yuk, bikin game pertamamu. Pilih template, edit blok, lalu tekan ▶ Mainkan!',
  onboardingSesi1Cta: 'Mulai sekarang',
  onboardingSesi1Done: 'Kamu sudah bisa bikin game! Keren!',

  // Onboarding tour (F-07 Sesi 2)
  onboardingSesi2Title: '🔥 Tambah blok sendiri',
  onboardingSesi2Body:
    'Coba tambah blok "gerak kanan" dari kategori Motion. Tap kategori, tap blok!',
  onboardingSesi2Cta: 'Oke, coba',
  onboardingSesi2Done: 'Makin jago! Kamu baru saja belajar debugging.',

  // Onboarding tour (F-07 Sesi 3 — STUB sampai F-06.B selesai)
  onboardingSesi3Title: '🔗 Bagikan ke ortu',
  onboardingSesi3Body:
    'Nanti kamu bisa share game kamu lewat QR atau link. (Fitur ini akan datang segera!)',
  onboardingSesi3Cta: 'Oke',
  onboardingSesi3PlaceholderHint: 'Bagikan game kamu → tunggu M6.B selesai',

  // Hint cards (F-07 §15.2)
  hintCardDismiss: 'Tutup',
  hintCardDisableAll: 'Jangan tampilkan lagi',
  hintCardIdleTitle: '💡 Coba ini',
  hintCardKikoBubble: '🦊 Kiko: Hei! Coba tambah blok ya!',

  // Parent guide modal (F-07 §15.3)
  parentGuideTitle: '📖 Panduan Orang Tua',
  parentGuideIntro:
    'TM Studio bantu anak belajar computational thinking lewat blok visual + game Phaser. Tidak perlu coding experience!',
  parentGuideFaq1Q: 'Apakah anak saya aman dari konten berbahaya?',
  parentGuideFaq1A: 'Ya. Semua aset sudah dikurasi tim TM. Tidak ada upload konten dari user.',
  parentGuideFaq2Q: 'Apa yang dipelajari anak?',
  parentGuideFaq2A:
    'Computational Thinking: dekomposisi, pattern recognition, abstraction, debugging. Lihat kurikulum di https://terusmengajar.id/kurikulum.',
  parentGuideFaq3Q: 'Berapa lama sesi yang ideal?',
  parentGuideFaq3A:
    '15–30 menit per sesi, 2–3 kali seminggu. Jangan dipaksa — biarkan eksplorasi natural.',
  parentGuideClose: 'Tutup',
  parentGuideOpenLabel: 'Buka panduan orang tua',

  // Header help button (F-07)
  headerHelp: '❓ Bantuan',
}
